import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row pt-10" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "badge border border-2 border-ispk-active" }
const _hoisted_6 = { class: "text-ispk-active" }
const _hoisted_7 = { class: "row g-5 py-5" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Lampiran", -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4\"><div class=\"d-flex flex-column bg-ispk-primary bg-gradient p-10 rounded-3\"><div class=\"text-left p-5\"><h2 class=\"text-white\"> Tidak dapat mencari apa yang anda perlukan? </h2><span class=\"text-white\">Try this next steps:</span></div><div class=\"d-inline-flex align-items-end p-5 bg-light rounded-3\"><div class=\"btn btn-sm btn-icon btn-secondary me-5\"><i class=\"bi bi-headset text-primary\"></i></div><div class=\"d-flex flex-column\"><span class=\"fw-bold\">Hubungi Kami</span><small>Team kami sedia membantu anda</small></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.details.tajuk), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getTypeText(_ctx.details.jenis)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "mb-5",
          innerHTML: _ctx.details.kandungan
        }, null, 8, _hoisted_9),
        (_ctx.details.lampiran_meta.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_10,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details.lampiran_meta, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("a", {
                      href: item.url,
                      target: "_blank"
                    }, _toDisplayString(item.nama_asal), 9, _hoisted_11)
                  ]))
                }), 128))
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _hoisted_12
    ])
  ]))
}